import InboxContent from './InboxContent';

export default InboxContent;
